import { SDownload } from '../../rest/types/api/Download'
import { DownloadFilesProps } from '../../components/DownloadFiles'
import { api } from '../../configuration'

export function DownloadTransformer({
  data,
  t,
}: {
  data?: SDownload[] | null
  t?: any
}): DownloadFilesProps | undefined {
  return data
    ? {
        title: t('download_label'),
        items: data.map((item) => ({
          label: item?.caption ?? '',
          link: {
            href: `${api.API_URL}${item?.url ?? ''}`,
          },
        })),
      }
    : undefined
}
